import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';

export class SuperLollipopSadPets extends View {
  private lollipop: ImageScaleView;
  private pet1: ImageScaleView;
  private pet2: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      width: downscale(554),
      height: downscale(324),
    });

    this.lollipop = new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/lollipop.png`,
      width: downscale(456),
      height: downscale(456),
      scaleMethod: 'contain',
      centerOnOrigin: true,
      scale: 0.7,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5 - 10,
      zIndex: 1,
    });

    new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/shadow.png`,
      width: downscale(214),
      height: downscale(29),
      scaleMethod: 'contain',
      x: this.lollipop.style.x,
      y: 205,
      centerOnOrigin: true,
    });

    this.pet1 = new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/sad_pet_1.png`,
      width: downscale(183),
      height: downscale(189),
      scaleMethod: 'contain',
      x: this.style.width * 0.5 - 185,
      y: this.style.height * 0.5 - 20,
      anchorX: downscale(183) / 2,
      anchorY: downscale(189),
      zIndex: 2,
    });

    new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/shadow.png`,
      width: downscale(214),
      height: downscale(29),
      scaleMethod: 'contain',
      x: this.pet1.style.x + this.pet1.style.width / 2,
      y: 210,
      centerOnOrigin: true,
      scale: 0.8,
    });

    this.pet2 = new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/sad_pet_2.png`,
      width: downscale(194),
      height: downscale(210),
      scaleMethod: 'contain',
      x: this.style.width * 0.5 + 55,
      y: this.style.height * 0.5 - 40,
      anchorX: downscale(194) / 2,
      anchorY: downscale(210),
      zIndex: 2,
    });

    new ImageScaleView({
      superview: this,
      image: `assets/ui/superLollipop/shared/shadow.png`,
      width: downscale(214),
      height: downscale(29),
      scaleMethod: 'contain',
      x: this.pet2.style.x + this.pet2.style.width / 2,
      y: 205,
      centerOnOrigin: true,
      scale: 0.8,
    });
  }

  public tick() {
    const now = Date.now();

    this.pet1.updateOpts({
      scaleY: 1 + Math.sin(now * 0.013) * 0.05,
    });

    this.pet2.updateOpts({
      r: Math.sin(now * 0.01) * 0.05,
    });
  }
}
